import { Box, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import InfoIcon from "@mui/icons-material/Info";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { TextField } from "@mui/material";
import { themes } from "services/constants";
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

export function CustomSftCategoryStepIcon(props) {
  const { active, completed, icon } = props;

  const icons = {
    1: <InfoIcon />,
    2: <MonetizationOnIcon />,
    3: <RemoveCircleIcon />,
    4: <VisibilityIcon />,
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: 40,
        height: 40,
        borderRadius: "50%",
        bgcolor: completed ? "#00D4AA" : active ? "#00D4AA" : "rgba(0,0,0,0.1)",
        color: "white",
      }}
    >
      {completed ? <CheckIcon /> : icons[String(icon)]}
    </Box>
  );
}

export const steps = [
  { label: "Basic Info" },
  { label: "Earning" },
  { label: "Deductions" },
  { label: "Preview" },
];

export const type = [
  {
    label: "Individual OT",
  },
  {
    label: "Per Day",
  },
  {
    label: "Per Cycle",
  },
];

export const sftType = [
  {
    label: "Per Session",
  },
  {
    label: "Per Day",
  },
  {
    label: "Per Cycle",
  },
];

//Basic Info
export const paymentOptions = [
  {
    id: "Full Shift Credit",
    label: "Full Shift Credit",
    description:
      "If the employee is present (even partial day within minimum threshold), credit full shift hours/pay.",
  },
  {
    id: "Partial Shift Credit",
    label: "Partial Shift Credit",
    description:
      "Credit full shift if hours worked ≥ minimum required hours, else pre-rota.",
  },
  {
    id: "Working Hours",
    label: "Working Hours",
    description: "Payment is calculated based on actual hours worked.",
  },
];

export const shiftGradeOptions = [
  {
    id: "Shift Hours",
    label: "Shift Hours",
    description: "Calculate working hours strictly as per the shift hours.",
  },
  {
    id: "Grade Hours",
    label: "Grade Hours",
    description: "Calculate working hours strictly as per the shift grade.",
  },
  {
    id: "Adjust Only if shift hour is Higher",
    label: "Adjust Only if shift hour is Higher",
    description:
      "Modify hours only if assigned shift hours exceed grade hours.",
  },
  {
    id: "Adjust Only if shift hour is Lower",
    label: "Adjust Only if shift hour is Lower",
    description:
      "Modify hours only if assigned shift hours are less than grade hours.",
  },
];

//Earnings

export const otPreauthorizationOptions = [
  {
    id: "Automatic",
    label: "Automatic",
    description:
      "OT requests are auto-approved based on predefined rules without approver action.",
    selected: true,
  },
  {
    id: "Manual",
    label: "Manual",
    description:
      "OT requests require approver review and approval before being processed.",
    selected: false,
  },
];

export const otTimingOptions = [
  {
    id: "Only Before",
    label: "Before shift",
    description: "Counts overtime worked before the scheduled shift start.",
  },
  {
    id: "Only After",
    label: "After shift",
    description: "Counts overtime worked after the scheduled shift end.",
  },
  {
    id: "Before and After",
    label: "Both",
    description:
      "Counts overtime worked both before the shift start and after the shift end.",
  },
];

export const calculationOptions = [
  {
    id: "Hours",
    label: "Hours",
    description:
      "Counts overtime by actual hours, either from attendance or a fixed rate.",
  },
  {
    id: "Shift",
    label: "Shift",
    description: "OT is calculated per shift. You can define criteria.",
  },
];

export const otPaymentOptions = [
  {
    id: "Attendance",
    label: "Attendance",
    description:
      "OT is calculated from actual worked hours after the minimum duration set.",
  },
  {
    id: "Amount",
    label: "Fixed Amount",
    description:
      "A set amount is paid once the OT threshold is reached with additional pay for the extra time.",
  },
];

export const weekoffPaymentOptions = [
  {
    id: "Attendance",
    label: "Attendance",
    description:
      "Pay is calculated based on daily wage using a multiplier (factor).",
  },
  {
    id: "Amount",
    label: "Fixed Amount",
    description: "A set amount is paid regardless of attendance or daily wage.",
  },
];

export const holidayPaymentOptions = [
  {
    id: "Attendance",
    label: "Attendance",
    description:
      "Pay is calculated based on daily wage using a multiplier (factor).",
  },
  {
    id: "Amount",
    label: "Fixed Amount",
    description: "A set amount is paid regardless of attendance or daily wage.",
  },
];

export const isAbsenceOptions = [
  {
    id: "Paid",
    label: "Paid",
    description: "Absence is paid in full, no salary deduction.",
  },
  {
    id: "Partially Paid",
    label: "Partially Paid",
    description:
      "Absence is partly paid based on a payment factor (eg.,02,0,5).",
  },
];

// deductions

export const penaltyOptions = [
  {
    id: "hours",
    label: "Hours",
    description:
      "Calculated based on hours and minutes of employee late arrival or early exit.",
    selected: true,
  },
  {
    id: "shift",
    label: "Shift",
    description:
      "Calculated based on the employee's late arrival or early exit in the assigned shift.",
    selected: false,
  },
  {
    id: "count",
    label: "Count",
    description:
      "Number of times an employee arrived late or exited early in the pay run cycle.",
    selected: false,
  },
];

export const deductionOptions = [
  {
    id: "Attendance",
    label: "Attendance",
    description: "Pay is linked to daily wage using a multiplier (factor).",
    selected: false,
  },
  {
    id: "Amount",
    label: "Fixed Amount",
    description: "Fixed penalty amount, independent of daily wage.",
    selected: true,
  },
];

export const breakOptions = [
  {
    id: "always",
    label: "Apply always",
    description:
      "Break penalty applies if employees exceed the allowed break time during their shift, even if their total working hours go beyond the shift hours.",
    selected: false,
  },
  {
    id: "deficit",
    label: "Only for Deficit Working Hours",
    description:
      "Break penalty applies only if the total working hours fall short of the required shift hours.",
    selected: true,
  },
];

export const FullShiftCreditExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    Worked{" "}
    <Box component="span" fontWeight="bold">
      5
    </Box>{" "}
    out of{" "}
    <Box component="span" fontWeight="bold">
      8
    </Box>{" "}
    hours → still credited as{" "}
    <Box component="span" fontWeight="bold">
      1
    </Box>{" "}
    full day.
  </Typography>
);

export const PartialShiftCreditExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    Minimum{" "}
    <Box component="span" fontWeight="bold">
      6
    </Box>{" "}
    hours → if worked ≥{" "}
    <Box component="span" fontWeight="bold">
      6
    </Box>{" "}
    hrs, full pay; else{" "}
    <Box component="span" fontWeight="bold">
      50%
    </Box>{" "}
    pay.
  </Typography>
);

export const WorkingHoursExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    Worked{" "}
    <Box component="span" fontWeight="bold">
      5
    </Box>{" "}
    out of{" "}
    <Box component="span" fontWeight="bold">
      8
    </Box>{" "}
    hours → credited{" "}
    <Box component="span" fontWeight="bold">
      5/8th
    </Box>{" "}
    of the day’s pay.
  </Typography>
);

export const ShiftWorkExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    if an employee works{" "}
    <Box component="span" fontWeight="bold">
      75%
    </Box>{" "}
    of a shift, it is counted as{" "}
    <Box component="span" fontWeight="bold">
      0.75
    </Box>{" "}
    of a shift. After that, every additional{" "}
    <Box component="span" fontWeight="bold">
      15%
    </Box>{" "}
    will be considered as{" "}
    <Box component="span" fontWeight="bold">
      0.5
    </Box>{" "}
    shift.
  </Typography>
);

export const PaymentBasedAttendanceExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    if minimum duration ={" "}
    <Box component="span" fontWeight="bold">
      60
    </Box>{" "}
    mins → First{" "}
    <Box component="span" fontWeight="bold">
      60
    </Box>{" "}
    not counted. Extra{" "}
    <Box component="span" fontWeight="bold">
      30
    </Box>{" "}
    mins worked = counted as OT.{" "}
  </Typography>
);

export const PaymentBasedFixedAmountExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    If threshold ={" "}
    <Box component="span" fontWeight="bold">
      50
    </Box>{" "}
    mins →{" "}
    <Box component="span" fontWeight="bold">
      ₹100
    </Box>{" "}
    is given. For extra{" "}
    <Box component="span" fontWeight="bold">
      30
    </Box>{" "}
    mins → additional{" "}
    <Box component="span" fontWeight="bold">
      ₹50
    </Box>{" "}
    is paid.
  </Typography>
);

export const PaidWeekOffExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    If daily wage ={" "}
    <Box component="span" fontWeight="bold">
      ₹1000
    </Box>{" "}
    and Payment Factor ={" "}
    <Box component="span" fontWeight="bold">
      2
    </Box>{" "}
    → Employee gets{" "}
    <Box component="span" fontWeight="bold">
      ₹2000
    </Box>{" "}
    for working on a weekoff.
  </Typography>
);

export const IsAbsenceExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    Daily salary ={" "}
    <Box component="span" fontWeight="bold">
      ₹1000
    </Box>{" "}
    and Payment Factor ={" "}
    <Box component="span" fontWeight="bold">
      0.5
    </Box>{" "}
    → the employee gets{" "}
    <Box component="span" fontWeight="bold">
      ₹500,
    </Box>{" "}
    deduction{" "}
    <Box component="span" fontWeight="bold">
      ₹500
    </Box>
  </Typography>
);

export const IsAbsencePaidExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    Daily salary{" "}
    <Box component="span" fontWeight="bold">
      ₹1000
    </Box>{" "}
    → Absent{" "}
    <Box component="span" fontWeight="bold">
      2
    </Box>{" "}
    days → Salary unchanged.
  </Typography>
);

export const PaidHolidayExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    If Fixed Amount ={" "}
    <Box component="span" fontWeight="bold">
      ₹1500
    </Box>{" "}
    → Employee gets{" "}
    <Box component="span" fontWeight="bold">
      ₹1500
    </Box>{" "}
    for working on a holiday, no matter their wage.
  </Typography>
);

export const SftPenaltyPolicyExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    If Threshold ={" "}
    <Box component="span" fontWeight="bold">
      15 mins
    </Box>{" "}
    → 15 mins is deducted. For every additional{" "}
    <Box component="span" fontWeight="bold">
      15 mins
    </Box>{" "}
    late/early → another{" "}
    <Box component="span" fontWeight="bold">
      15 mins
    </Box>{" "}
    is deducted.
  </Typography>
);

export const SftPenaltyPolicySftExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    If Threshold ={" "}
    <Box component="span" fontWeight="bold">
      15 mins
    </Box>{" "}
    →{" "}
    <Box component="span" fontWeight="bold">
      0.5
    </Box>{" "}
    shift deducted. For every additional{" "}
    <Box component="span" fontWeight="bold">
      15 mins
    </Box>{" "}
    early/late → another{" "}
    <Box component="span" fontWeight="bold">
      0.5 shift
    </Box>{" "}
    deducted.
  </Typography>
);

export const SftPenaltyPolicyCountExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    If Late/Early threshold count ={" "}
    <Box component="span" fontWeight="bold">
      2
    </Box>{" "}
    →{" "}
    <Box component="span" fontWeight="bold">
      0.5
    </Box>{" "}
    shift deducted.Each additional count →{" "}
    <Box component="span" fontWeight="bold">
      0.25
    </Box>{" "}
    shift deducted.
  </Typography>
);

export const SftDeductBreakPenaltyPolicyExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    If allowed break ={" "}
    <Box component="span" fontWeight="bold">
      30
    </Box>{" "}
    mins, and employee takes{" "}
    <Box component="span" fontWeight="bold">
      45
    </Box>{" "}
    mins → extra{" "}
    <Box component="span" fontWeight="bold">
      15
    </Box>{" "}
    mins deducted from working hours.{" "}
  </Typography>
);

export const SftDeductSalaryForAbsenceExample = () => (
  <Typography variant="body2" color="text.secondary">
    <Box
      component="span"
      sx={{
        fontWeight: 600,
        color: "primary.main",
        textTransform: "lowercase",
      }}
    >
      e.g.,
    </Box>{" "}
    Absent day is unpaid, with an additional ={" "}
    <Box component="span" fontWeight="bold">
      0.5
    </Box>{" "}
    day penalty. For{" "}
    <Box component="span" fontWeight="bold">
      24
    </Box>{" "}
    present days,{" "}
    <Box component="span" fontWeight="bold">
      2
    </Box>{" "}
    absent days,total deduction ={" "}
    <Box component="span" fontWeight="bold">
      1
    </Box>{" "}
    day from present days ={" "}
    <Box component="span" fontWeight="bold">
      24 - 1 = 23.
    </Box>{" "}
  </Typography>
);

export const boxStyle = (isActive) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  bgcolor: "#f5f5fd",
  px: 2,
  py: 1,
  borderBottom: isActive ? "1px solid #00000020" : "none",
  mb: isActive ? 2 : 0,
});

export const CustomTable = ({ data }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 2,
        boxShadow: "none",
        border: "1px solid #e0e0e0",
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: "#f7f7fb" }}>
            <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
              Min % Completed
            </TableCell>
            <TableCell sx={{ fontWeight: 600, textAlign: "center" }}>
              Count as Shift
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell sx={{ textAlign: "center" }}>
                {row.work_min_percentage}
              </TableCell>
              <TableCell sx={{ textAlign: "center" }}>
                {row.count_as_shift}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const amountRegex = /^[0-9]{0,5}$/;
const percentageRegex = /^(?:\d{0,2}(?:\.\d{0,2})?)?$/;
const shiftRegex = /^[0-9]?(\.\d{0,2})?$/;
const minutesRegex = /^\d{0,3}$/;

export const CustomBox = ({
  name,
  value,
  register,
  errors,
  handleChange,
  rules,
  inputWidth,
  type,
}) => {
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    const regex =
      type === "percentage"
        ? percentageRegex
        : type === "shift"
        ? shiftRegex
        : type === "amount"
        ? amountRegex
        : type === "minutes"
        ? minutesRegex
        : null;

    if (regex.test(inputValue)) {
      handleChange(event, inputValue);
    }
  };

  return (
    <TextField
      size="small"
      value={value}
      inputProps={{
        style: {
          textAlign: "center",
          width: inputWidth ?? "50px",
          height: "16px",
        },
      }}
      {...register(name, rules)}
      onChange={handleInputChange}
      error={Boolean(errors[name])}
      helperText={errors[name]?.message || ""}
    />
  );
};

export const mainOptions = {
  border: "1px solid #00000040",
  borderRadius: 2,
  overflow: "hidden",
  mb: 2,
};

export const boxStyleSx = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  py: 1,
  pl: 3,
};

export const optionsStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: 2,
  px: 2,
  py: 1,
};
export const individualBoxStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 1,
};

export const amtFactorStyle = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 1,
  ml: 4,
  mt: 1,
};

export const additionalInfoStyle = {
  border: `1px solid ${themes.miliedLightGray}`,
  ml: 2,
  mr: 2,
  p: 1,
  mb: 2,
  borderRadius: 1,
};

export const infoMessageStyle = {
  border: `1px solid ${themes.miliedLightGray}`,
  p: 1.5,
  backgroundColor: "#fff6cc",
  borderRadius: 1,
  ml: 2,
  mr: 2,
  mb: 2,
};

export const cardStyle = (isActive) => ({
  flex: 1,
  border: `1px solid ${
    isActive ? themes.stepActiveColor : themes.miliedLightGray
  }`,
  borderRadius: 2,
  p: 1,
  transition: "all 0.2s ease",
  "&:hover": {
    borderColor: themes.stepActiveColor,
  },
});
